import React, { Component, FormEventHandler } from 'react';
import Button from '~/UI/Button';
import buttonPrimaryWideStyles from '~/UI/Button/primary-wide.less';
import FormFieldError from '~/UI/FormFieldError/FormFieldError';
import Heading from '~/UI/Heading';
import Input from '~/UI/Input/Input';
import wideInputStyles from '~/UI/Input/wide.less';

import styles from './styles.less';

interface Props {
	title: string;
	changeButtonLabel: string;
	isFetching: boolean;
	onFetch(): void;
	onAccept(
		password: string,
		passwordCheck: string
	): Promise<{
		passwordError: string | null;
		passwordCheckError: string | null;
	}>;
}

interface State {
	password: string;
	passwordCheck: string;
	passwordError: string | null;
	passwordCheckError: string | null;
}

export default class PasswordChangePage extends Component<Props, State> {
	state = {
		password: '',
		passwordCheck: '',
		passwordError: null,
		passwordCheckError: null,
	};

	componentDidMount() {
		this.props.onFetch();
	}

	handleFormSubmit: FormEventHandler = (event) => {
		const {
			state: { password, passwordCheck },
			props: { onAccept },
		} = this;

		event.preventDefault();
		this.setState({ passwordError: null, passwordCheckError: null });

		onAccept(password.trim(), passwordCheck.trim()).then((errors) => {
			if (errors.passwordError !== null || errors.passwordCheckError !== null) {
				this.setState(errors);
			}
		});
	};

	render() {
		const {
			props: { title, changeButtonLabel, isFetching },
			state: { password, passwordCheck, passwordError, passwordCheckError },
		} = this;

		return (
			<section className={styles.section}>
				<div className={styles.in}>
					<form data-testid='password-form' onSubmit={this.handleFormSubmit}>
						<Heading>{title}</Heading>

						<div className={styles.form}>
							<Input
								disabled={isFetching}
								isInvalid={passwordError !== null}
								name='password'
								placeholder='Password'
								styles={wideInputStyles}
								type='password'
								value={password}
								onChange={(event) => this.setState({ password: event.currentTarget.value })}
							/>
							{passwordError !== null ? <FormFieldError>{passwordError}</FormFieldError> : null}

							<Input
								disabled={isFetching}
								isInvalid={passwordCheckError !== null}
								name='password-check'
								placeholder='Repeat password'
								styles={wideInputStyles}
								type='password'
								value={passwordCheck}
								onChange={(event) => this.setState({ passwordCheck: event.currentTarget.value })}
							/>
							{passwordCheckError !== null ? <FormFieldError>{passwordCheckError}</FormFieldError> : null}

							<Button disabled={password === '' || isFetching} styles={buttonPrimaryWideStyles}>
								{changeButtonLabel}
							</Button>
						</div>
					</form>
				</div>
			</section>
		);
	}
}
